export type OsShortcutId =
  | "CLOSE_ACTIVE_WINDOW"
  | "TOGGLE_GLOBAL_SEARCH"
  | "TOGGLE_ANI_ASSISTANT";

export interface OsShortcutDefinition {
  id: OsShortcutId;
  key: string;
  metaOrCtrl?: boolean;
  macLabel: string;
  winLabel: string;
}

export const OS_SHORTCUTS: Record<OsShortcutId, OsShortcutDefinition> = {
  CLOSE_ACTIVE_WINDOW: {
    id: "CLOSE_ACTIVE_WINDOW",
    key: "Escape",
    macLabel: "Esc",
    winLabel: "Esc",
  },
  TOGGLE_GLOBAL_SEARCH: {
    id: "TOGGLE_GLOBAL_SEARCH",
    key: "k",
    metaOrCtrl: true,
    macLabel: "⌘K",
    winLabel: "Ctrl+K",
  },
  TOGGLE_ANI_ASSISTANT: {
    id: "TOGGLE_ANI_ASSISTANT",
    key: "/",
    metaOrCtrl: true,
    macLabel: "⌘/",
    winLabel: "Ctrl+/",
  },
};

export function getShortcutLabel(
  shortcutId: OsShortcutId,
  isMac: boolean,
): string {
  const shortcut = OS_SHORTCUTS[shortcutId];
  return isMac ? shortcut.macLabel : shortcut.winLabel;
}

export function isTypingInInput(event: KeyboardEvent): boolean {
  const target = event.target;
  if (!(target instanceof HTMLElement)) {
    return false;
  }

  if (target.isContentEditable) {
    return true;
  }

  const contentEditable = target.getAttribute("contenteditable");
  if (contentEditable === "" || contentEditable === "true") {
    return true;
  }

  const tagName = target.tagName;
  return tagName === "INPUT" || tagName === "TEXTAREA" || tagName === "SELECT";
}

export function matchesShortcut(
  event: KeyboardEvent,
  shortcutId: OsShortcutId,
): boolean {
  const shortcut = OS_SHORTCUTS[shortcutId];

  if (shortcut.metaOrCtrl) {
    if (!(event.metaKey || event.ctrlKey)) {
      return false;
    }
  } else if (event.metaKey || event.ctrlKey || event.altKey) {
    return false;
  }

  if (shortcut.key.length === 1) {
    return event.key.toLowerCase() === shortcut.key.toLowerCase();
  }

  return event.key === shortcut.key;
}
